/* MUSLIMFY — Shipping Bar
 * Met a jour la barre de progression livraison gratuite en temps reel.
 *
 * Lecture des dataset attributes poses cote Liquid :
 *   data-threshold-cents : seuil en centimes (ex: 10000 pour 100 EUR)
 *   data-threshold-eur   : seuil en euros (ex: 100)
 *   data-code            : code promo a inserer dans [code]
 *   data-text-progress   : template avant le seuil (placeholders [amount] et [code])
 *   data-text-complete   : template au seuil atteint (placeholders [threshold] et [code])
 *
 *   NOTE : placeholders avec [] (pas {}) car Shopify Liquid parser ne supporte
 *   pas les accolades imbriquees dans les string defaults — l'erreur etait
 *   "Variable was not properly terminated with regexp /\}\}/" sur les
 *   {{ settings.cd_shipping_text_X | default: '... {amount} ...' }}.
 *
 * Hooks :
 *   - DOMContentLoaded                     : sync initial
 *   - change sur input[name="updates[]"]   : modif quantity input
 *   - click sur plus/minus/cart-remove     : modif via boutons
 *   - cart:refresh / cart:updated          : events theme natifs
 *
 * Apres detection d'un changement, on attend ~600ms (le temps que Shopify
 * ait fini son /cart/change.js) puis on fetch /cart.js pour avoir le total
 * a jour, et on update toutes les barres visibles.
 *
 * Format monetaire : on respecte le format Shopify natif via Shopify.formatMoney
 * si disponible, sinon fallback "X,YY EUR".
 */
(function () {
  'use strict';

  var ROUTE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DEBOUNCE_MS = 600;
  var debounceTimer = null;

  function fmtMoney(cents, bar) {
    // Format MUSLIMFY : "49,90€" (montant + EUR colle apres, locale FR avec virgule).
    // On ne s'appuie pas sur Shopify.formatMoney qui suit shop.money_format
    // (typiquement "€49,90" — symbole avant). On force notre format coherent.
    var cur = (bar && bar.getAttribute('data-currency')) || 'EUR';
    var symbol = cur === 'EUR' ? '€' : (cur === 'USD' ? '$' : (cur === 'GBP' ? '£' : cur));
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + symbol;
  }

  function updateBar(bar, totalCents) {
    var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10) || 0;
    var thresholdEur = bar.getAttribute('data-threshold-eur') || '';
    var code = bar.getAttribute('data-code') || '';
    var textProgress = bar.getAttribute('data-text-progress') || '';
    var textComplete = bar.getAttribute('data-text-complete') || '';
    if (threshold <= 0) return;

    var pct = Math.max(0, Math.min(100, Math.round((totalCents / threshold) * 100)));
    var fill = bar.querySelector('[data-cd-shipping-fill]');
    var textEl = bar.querySelector('[data-cd-shipping-text]');
    if (fill) fill.style.width = pct + '%';

    var msg;
    if (totalCents >= threshold) {
      msg = textComplete
        .split('[code]').join(code)
        .split('[threshold]').join(thresholdEur);
      bar.classList.add('is-complete');
    } else {
      var remaining = threshold - totalCents;
      msg = textProgress
        .split('[amount]').join(fmtMoney(remaining, bar))
        .split('[code]').join(code)
        .split('[threshold]').join(thresholdEur);
      bar.classList.remove('is-complete');
    }
    if (textEl) textEl.textContent = msg;
  }

  function refresh() {
    var bars = document.querySelectorAll('[data-cd-shipping-bar]');
    if (!bars.length) return;
    fetch(ROUTE + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var total = cart.total_price || 0;
        for (var i = 0; i < bars.length; i++) updateBar(bars[i], total);
      })
      .catch(function () { /* silent */ });
  }

  function schedule() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, DEBOUNCE_MS);
  }

  // Hook 1 : changements quantity input (cart drawer + cart page)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'updates[]') schedule();
  });
  // Hook 2 : clicks plus / minus / remove
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var btn = el.closest('button[name="plus"], button[name="minus"], cart-remove-button button');
    if (btn) schedule();
  });
  // Hook 3 : events Shopify standard
  document.addEventListener('cart:refresh', function () { setTimeout(refresh, 200); });
  document.addEventListener('cart:updated', function () { setTimeout(refresh, 200); });

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 300); });
  } else {
    setTimeout(refresh, 300);
  }
})();
